import _ from 'underscore';
import {
  createRequestContract,
  createResponseContract,
  createSpec,

  requestVerbs,
  responseTypes,
  specTypes,
} from '@bingads-webui-react/overreact';

import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../../env/edm';
import { environmentLookupFn } from '../../../../../../env/env-instance';
import { schema } from '../../../../../../env/schema';

import {
  headerDecorator,
  sideEffects,

  networkPolicy,
} from './destroy-decorators';

function odataUrlFactory(params) {
  const { variables } = params;
  const { locator: { descriptor } } = variables;
  const {
    customer_id: CustomerId,
    account_id: AccountId,
    tag_id: TagId,
  } = descriptor;

  const edmEntity = edm
    .Customers.$withKey(CustomerId)
    .Accounts.$withKey(AccountId)
    .Tags.$withKey(TagId);

  const searchString = composeSearchString(variables, edmEntity, false);
  return `${edmEntity.path}${searchString}`;
}

function odataHeaderFactory(params) {
  const { headers } = params;
  return headers;
}

const requestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:tag',
  verb: requestVerbs.DELETE,
  fetchPolicy: networkPolicy,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: headerDecorator(odataHeaderFactory),
  keySelector: variables => variables.locator.descriptor.tag_id,
  parentKeySelector: variables => variables.locator.descriptor.account_id,
});

const responseContract = createResponseContract({
  requestContract,
  responseType: responseTypes.ENTITY,
  keySelector: _.identity,
  processorFn: _.identity,
});

export const destroySpec = createSpec(
  requestContract,
  responseContract,
  specTypes.DELETE,
  sideEffects.destroy,
  environmentLookupFn
);
